// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"61b5662e","732":"9ccee5b1","977":"344ff7aa"}[chunkId] + ".chunk.js";
};